import React from 'react'
import './FlexContainer.scss'
import { ComponentMapping, Container } from '@adobe/aem-react-editable-components';
import { SizeContext } from '../../contexts/resize-context';
import { scrollIntoComponent } from '../../utils/scrollIntoComponent';

class FlexContainer extends Container {
    static contextType = SizeContext
    constructor(props) {
        super(props);
        this.state = {
            componentMapping: this.props.componentMapping || ComponentMapping,
            items: this.childComponents,
            showItems: this.childComponents.length,
        };
        
        this.handleShowMore = this.handleShowMore.bind(this)
        this.timerRef = React.createRef()
    }

    componentDidMount() {
        const { scrollIntoView } = scrollIntoComponent(this.props.id, this.props.isInEditor);
        this.timerRef.current = scrollIntoView();
        if (!this.props.isInEditor && this.props.appliedCssClassNames?.includes('same-height-table')) {
            let maxHeightTitle = 0
            this.props.cqItemsOrder.map((table, i) => {
                let item = this.props.cqItems[table]
                let tableDOM = document.getElementById(item?.id)
                let feature = tableDOM?.querySelector(`.comparative-table__description`)
                if (feature?.clientHeight > maxHeightTitle) {
                    maxHeightTitle = feature.clientHeight
                }
            })
            this.props.cqItemsOrder.map((table, i) => {
                let item = this.props.cqItems[table]
                let tableDOM = document.getElementById(item.id)
                let feature = tableDOM?.querySelector(`.comparative-table__description`)
                if (feature) {
                    feature.style.height = maxHeightTitle + "px"
                }
            })

            let countRows = 0
            let firstElement = this.props.cqItems[this.props.cqItemsOrder[0]]
            if (firstElement) {
                countRows = firstElement.comparativeTable?.features?.itemFeature?.length
            }

            for (let index = 0; index < countRows; index++) {
                let maxHeight = 0
                this.props.cqItemsOrder.map((table, i) => {
                    let item = this.props.cqItems[table]
                    let tableDOM = document.getElementById(item?.id)
                    let feature = tableDOM?.querySelector(`.comparative-table__row.item-${index}`)
                    if (feature?.clientHeight > maxHeight) {
                        setTimeout(() => {
                            if (feature?.clientHeight > maxHeight) {
                                maxHeight = feature.clientHeight
                            }
                        }, 1)
                    }
                })
                this.props.cqItemsOrder.map((table, i) => {
                    let item = this.props.cqItems[table]
                    let tableDOM = document.getElementById(item.id)
                    let feature = tableDOM.querySelector(`.comparative-table__row.item-${index}`)
                    if (feature) {
                        setTimeout(() => {
                            feature.style.height = maxHeight + "px"
                        }, 1)
                    }
                })
            }
        }

        if (!this.props.isInEditor && this.props.appliedCssClassNames?.includes('same-height-carddesplegable') && !this.context.isMobile) {
            let maxHeightTitle = 0
            this.props.cqItemsOrder.map((table, i) => {
                let item = this.props.cqItems[table]
                let tableDOM = document.getElementById(item?.id)
                let feature = tableDOM?.querySelector(`.carddesplegable--title`)
                if (feature?.clientHeight > maxHeightTitle) {
                    maxHeightTitle = feature.clientHeight
                }
            })
            this.props.cqItemsOrder.map((table, i) => {
                let item = this.props.cqItems[table]
                let tableDOM = document.getElementById(item.id)
                let feature = tableDOM?.querySelector(`.carddesplegable--title`)
                if (feature) {
                    feature.style.height = maxHeightTitle + "px"
                }
            })
        }
        this.setrows(); 
    }

    componentWillUnmount() {
        if (this.timerRef.current){
            clearTimeout(this.timerRef.current);
        }
    }

    setrows = () => {
        if (this.props?.flexContainer?.showmore && this.props.appliedCssClassNames?.includes('cols-3')){
            this.setState({
                showItems: 6
              })
        }else if(this.props?.flexContainer?.showmore && this.props.appliedCssClassNames?.includes('cols-2')){
            this.setState({
                showItems: 4
              })
        }else {
            this.setState({
                showItems: this.state.items.length
              })
        }
      }

    applyAlignment = () => {
        const grid = this.props?.flexContainer?.grid;
        let result = "";
        if (grid) {
            result = `grid ${grid} `;
            result += this.props?.flexContainer?.alignment ? `grid--${this.props?.flexContainer?.alignment}` : "grid--center";
        } else {
            result = this.props?.flexContainer?.alignment ? `flex-container--${this.props?.flexContainer?.alignment}` : 'flex-container--center';
        }
        return result;
    }

    handleShowMore(e) {
        if (this.props?.flexContainer?.showmore && this.props.appliedCssClassNames?.includes('cols-3')){
            this.setState({
                showItems: this.state.showItems + 6
              })
        }else if(this.props?.flexContainer?.showmore && this.props.appliedCssClassNames?.includes('cols-2')){
            this.setState({
                showItems: this.state.showItems + 4
              })
        }else {
            e.target.classList.add('disabled')
            this.setState({
                showItems: this.state.items.length
              })
        }
    }

    showbutton(){
        const col = this.state.items.length
        const isFull = this.state.showItems
        if (col <= isFull){
          return {
            display: "none" 
          }
        }
      }

    render() {
        return (
            <>
                <div
                    id={this.props.id}
                    className={`flex-container
                    ${
                        this.props?.flexContainer?.sameheight
                            ? 'flex-container--same-height'
                            : 'flex-container--not-same-height'
                    } 
                    ${this.applyAlignment()}
                    ${
                        !this.props.isInEditor &&
                        this.props.appliedCssClassNames?.includes('same-height-carddesplegable')
                            ? 'flex-container--cd'
                            : ''
                    }`}
                >
                    {!this.props.isInEditor &&
                        this.state.items.slice(0, this.state.showItems).map((item) => item)}
                    {this.props.isInEditor && this.childComponents.map((item) => item)}

                    {!this.props.isInEditor && this.props?.flexContainer?.showmore ? (
                        <button
                            tabIndex={0}
                            className={`flex-container--showdetails`}
                            role='button'
                            onClick={(e) => this.handleShowMore(e)}
                            style={this.showbutton()}
                        >
                            {this.showMoreItems == true
                                ? null
                                : this.props?.flexContainer?.showmoretext
                                ? this.props?.flexContainer?.showmoretext
                                : 'Mostrar más'}
                            {this.showMoreItems == true ? null : (
                                <i className='icon-right_arrow'></i>
                            )}
                        </button>
                    ) : null}
                </div>
                {this.placeholderComponent}
            </>
        );
    }

}

export default FlexContainer;